
export const EMPLOYEE_DASHBOARD = {
    nothing: 0,
    applications: 1,
    reports: 2,
    events: 3,
    stats: 4,
    settings: 5,
    affiliateApplications: 10,
    legacyApplications: 11,
    employeeApplications: 12,
};

export const EVENT_CONTROL = {
    nothing: 0,
    all: 1,
    active: 2,
    inactive: 3,
    archived: 4,
    add: 5,
};

export const EVENT_EDIT = {
    nothing: 0,
    editText: 1,
    addPictures: 2,
    all: 3,
    archiveEvent: 4,
    verifyEditsShowing: 5,
    attendingShowing: 10,
    signinsShowing: 11,
}


